module.exports = __webpack_public_path__ + "static/3-ae528bfd65c353ddff303dd5f7e74b55.svg";